import { InitialValues, ValidationErrors } from 'forms/types';
import { isPresent } from 'forms/validators';

import { HouseholdFormValues } from '../form/types';

export const validate = ({
  annualIncome,
}: InitialValues<HouseholdFormValues>): ValidationErrors<HouseholdFormValues> => ({
  annualIncome: isPresent(annualIncome),
});
